import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { TabsModule } from '@mem-shared/tabs/tabs.module';
// cf design comopnents
import { CfComponentsModule } from '@cf-design/components';

// ngx-modules
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap';
import { AccordionModule } from 'ngx-bootstrap/accordion';


// Member-Shared Services

// import { AlertsService } from '@mem-shared/alerts/alerts.service';
// import { BroadcastMessageService } from './broadcast-message/broadcast-message.service';
// import { CfTourService } from '@mem-shared/cf-tour.service';
import { DocViewerService } from './doc-viewer.service';
// import { DisclaimerService } from '../core/disclaimer/disclaimer.service';
import { EventService } from './event.service';
import { HolisticMemberProfileService } from './holistic-member-profile.service';
import { MemberAuditService } from './audit/member-audit.service';
// import { PromoBannerService } from '../core/promo-banner/promo-banner.service';
import { UpdateProfileService } from './update-profile/update-profile.service';
import { zipariLoginService } from './zipariLogin.service';
// import { SiteMapService } from './site-map/site-map.service';
import { UserSession } from './user-session';
import { UtilService } from 'app/shared/util.service';
import { UpdateLobService } from 'app/shared/update-lob.service';
// import { ViewportService } from './viewport.service';
import { DatePipe } from '@angular/common';
// import { PlanAdvisorService } from './plan-advisor-terms-conditions/plan-advisor.service'
import { WindowRef } from './windowRef.service';

// Member-Shared Components
import { AlertComponent } from './alert/alert.component';
import { ConfirmPhoneNumberComponent } from './update-profile/confirm-phone-number/confirm-phone-number.component';
import { LoaderComponent } from './loader/loader.component';
import { UpdateEmailComponent } from './update-profile/update-email/update-email.component';
import { UpdatePhoneNumberComponent } from './update-profile/update-phone-number/update-phone-number.component';

// Member-Shared Directives


// Member-Shared Guards
import { PreLoginGuard } from '@mem-shared/pre-login.guard';

// Member-Shared Modules
import { SharedPipesModule } from '@mem-shared/pipes/shared-pipes.module';
import { DatepickerModule } from './datepicker/datepicker.module';
import { HttpClientModule } from '@angular/common/http';

export function getLocalStorage() {
  return typeof window !== 'undefined' ? window.localStorage : null;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DatepickerModule,
    ReactiveFormsModule,    
    TranslateModule.forChild(),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    CfComponentsModule,
    TextMaskModule,
    SharedPipesModule,
    HttpClientModule,
    AccordionModule,
    TabsModule.forRoot()
    // WebConnectModule    
  ],
  exports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    DatepickerModule,
    CfComponentsModule,
    SharedPipesModule,
    UpdateEmailComponent,
    UpdatePhoneNumberComponent,
    ConfirmPhoneNumberComponent,
    ModalModule,
    AccordionModule,
    AlertComponent,
    LoaderComponent
  ],
  providers: [
    CookieService,
    MemberAuditService,
    UpdateProfileService,
    PreLoginGuard,
    //OnlineChatService,
    // provide localstorage here to be used in user session.
    // having this as a provider allows us to inject it with
    // DI and making unit testing easier.
    { provide: 'LOCALSTORAGE', useFactory: getLocalStorage }
    //IconService
  ], // these are still required for local module
  declarations: [
    
    LoaderComponent,
    UpdateEmailComponent,
    UpdatePhoneNumberComponent,
    ConfirmPhoneNumberComponent,
    AlertComponent
    //IconComponent,
 
  ],
  entryComponents: [

  ]
})
export class SharedModule {
  /**
   * This is so that the root appModule can
   * call forRoot(). This prevents the lazymodules
   * that include the sharedModule form getting a
   * new instance of the UserSession service.
   */
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,

      providers: [
        { provide: 'parentUserSession', useExisting: UserSession },
        { provide: 'parentMemberAuditService', useExisting: MemberAuditService },
        UserSession,
        DocViewerService,
        MemberAuditService,
        UtilService,
        UpdateLobService,
        EventService,
        HolisticMemberProfileService,
        UpdateProfileService,
        WindowRef,
        zipariLoginService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts